export const Separator = ({ style }) => <div style={{ width: "100%", height: "0px", ...(style || {}) }} className="border-bottom color-border-primary my-2" />
